import React, { useCallback } from "react";
import * as Styled from "./Sidebar.styles";
import { DownOutlined, FileDoneOutlined } from "@ant-design/icons";
import { Dropdown, Tooltip } from "antd";

import Locations from "../Locations/Locations";

import ReportModal from "../GenerateReports/ReportModal";
import { usePartner } from "../../context/PartnerContext";
import { useReportActions } from "../../hooks/useReportActions";
import { ReportIcon } from "./Sidebar.styles";
import { useNavigate } from "react-router-dom";

function Sidebar() {
  const navigate = useNavigate();
  const { partners = [], currentPartner } = usePartner();

  const { isOpen, openReport, closeReport } = useReportActions();
  const handleSelectedPartner = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, id: number) => {
      event.preventDefault();

      const partnerURL = `/${id}`;
      navigate(partnerURL);
    },
    [navigate]
  );
  const items = partners?.map((partner) => ({
    key: partner.key,
    label: (
      <a href="/#" onClick={(e) => handleSelectedPartner(e, partner.id)}>
        {partner.name}
      </a>
    ),
  }));

  return (
    <>
      <Styled.Aside className="overwrite" width={300}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Styled.Title
            style={{ display: "flex", alignItems: "center", gap: 6 }}
          >
            {currentPartner?.name ?? "Rooam"} Dashboard
            <Dropdown menu={{ items }} trigger={["click"]}>
              <Styled.Button id="partner-select-icon">
                <span>
                  <DownOutlined />
                </span>
              </Styled.Button>
            </Dropdown>
          </Styled.Title>
          <Tooltip title="Generate Report" placement="right">
            <Styled.ReportIcon
              role="button"
              onClick={openReport}
              aria-label="Generate report"
              className={ReportIcon}
            >
              <FileDoneOutlined />
            </Styled.ReportIcon>
          </Tooltip>
        </div>
        <Locations />
      </Styled.Aside>
      <ReportModal open={isOpen} onClose={closeReport} />
    </>
  );
}

export default Sidebar;
